// src/pages/PortalEventsPage.js
import React, { useState, useEffect } from 'react';
import portalApi from '../utils/portalApi';
import toast from 'react-hot-toast';

export default function PortalEventsPage() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    portalApi.get('/portal/events')
      .then(res => setEvents(res.data))
      .catch(() => toast.error('Failed to load events.'));
  }, []);

  if (events === null) return <div className="loading-page"><div className="spinner" /></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Events</h1>
          <p className="page-subtitle">Upcoming NJJBA events open to members</p>
        </div>
      </div>

      {events.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📅</div>
          <h3>No upcoming events</h3>
          <p>Check back soon!</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 16 }}>
          {events.map(ev => {
            const myTickets = parseInt(ev.my_tickets || 0);
            const soldOut = ev.ticket_types?.every(tt => !tt.available);
            return (
              <div key={ev.id} className="card" style={{ display: 'flex', flexDirection: 'column' }}>
                {ev.flyer_filename && (
                  <img
                    src={`/api/public/events/${ev.id}/flyer`}
                    alt={ev.name}
                    style={{ width: '100%', maxHeight: 220, objectFit: 'cover', borderRadius: '6px 6px 0 0' }}
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                )}
                <div className="card-body" style={{ flex: 1 }}>
                  <h3 style={{ fontSize: '1.1rem', marginBottom: 8 }}>{ev.name}</h3>
                  <div style={{ display: 'flex', gap: 12, alignItems: 'center', fontSize: '0.85rem', color: 'var(--gray-600)', marginBottom: 8, flexWrap: 'wrap' }}>
                    <span>📅 {fmtDate(ev.event_date)}{ev.start_time ? ` · ${fmtTime(ev.start_time)}` : ''}</span>
                    {ev.venue && <span>📍 {ev.venue}</span>}
                  </div>
                  {ev.description && (
                    <p style={{ fontSize: '0.875rem', color: 'var(--gray-700)', marginBottom: 12,
                                display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                                overflow: 'hidden' }}>
                      {ev.description}
                    </p>
                  )}

                  {ev.ticket_types?.length > 0 && (
                    <div style={{ fontSize: '0.8rem', color: 'var(--gray-500)', marginBottom: 12 }}>
                      {ev.ticket_types.map((tt, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                          <span>{tt.name}</span>
                          <span>
                            Member ${tt.memberPrice} / Non-member ${tt.nonMemberPrice}
                            {!tt.available && <span style={{ color: 'var(--danger)', marginLeft: 6 }}>Sold out</span>}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div style={{ padding: '12px 16px', borderTop: '1px solid var(--gray-200)', display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
                  {myTickets > 0 ? (
                    <>
                      <span className="badge badge-active">✓ Registered ({myTickets})</span>
                      <a href={`/embed/events/${ev.id}`} target="_blank" rel="noreferrer"
                         className="btn btn-secondary btn-sm">
                        Buy more
                      </a>
                    </>
                  ) : soldOut ? (
                    <span style={{ color: 'var(--danger)', fontWeight: 600 }}>Sold Out</span>
                  ) : (
                    <a href={`/embed/events/${ev.id}`} target="_blank" rel="noreferrer"
                       className="btn btn-primary btn-sm" style={{ marginLeft: 'auto' }}>
                      Register
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
}
function fmtTime(t) {
  if (!t) return '';
  const [h, m] = t.split(':');
  const hh = parseInt(h, 10);
  const ampm = hh >= 12 ? 'PM' : 'AM';
  const h12 = hh % 12 || 12;
  return `${h12}:${m} ${ampm}`;
}
